import React from 'react';
import { useHistory } from 'react-router';

// Types
import { ReviewTemplateTypeType } from 'Shared/types/ReviewTemplates.type';

// Utils
import PageUrlsUtil from 'Shared/utils/PageUrls.utils';
import { getReviewTemplateErrors } from 'Shared/utils/ReviewTemplate.utils';

// Hooks
import { useReviewTemplates } from 'Shared/utils/hooks/use-review-templates';
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';

// Components
import { WpButton } from 'Wpds/components/button';
import CoachingPageHeader from '../_partials/CoachingPageHeader';
import ReviewTemplateList from 'Shared/components/ReviewTemplateList/ReviewTemplateList';

const ReviewTemplates = () => {
  const history = useHistory();
  const { id: currentUserId } = useCurrentUser();

  const { templates, isFetching, handleCreateEmptyReviewTemplate } = useReviewTemplates({
    templateType: ReviewTemplateTypeType.review360,
  });

  const handleCreateNewTemplateClick = () => {
    handleCreateEmptyReviewTemplate().then(response => {
      history.push(PageUrlsUtil.makeCoachingFeedbackTemplateUrl({ slug: response.data.attributes.slug }));
    });
  };

  const baseClassName = 'ReviewTemplates';

  if (isFetching && templates.length === 0) return <>loading...</>;

  const filteredAndSortedTemplates = templates
    .filter(template => {
      const hasErrors = getReviewTemplateErrors({ reviewTemplate: template }).length > 0;
      return !hasErrors || (hasErrors && currentUserId === template.userId);
    })
    .sort((a, b) => (a.isCustom === b.isCustom ? 0 : !a.isCustom ? -1 : 1));

  return (
    <div className={baseClassName}>
      <CoachingPageHeader
        title="Templates"
        description="Create templates for use in your 360 feedback"
        size="lg"
        buttons={
          <WpButton variant="secondary" onClick={handleCreateNewTemplateClick}>
            Create template
          </WpButton>
        }
      />

      <ReviewTemplateList reviewTemplates={filteredAndSortedTemplates} handleChooseTemplate={null} />
    </div>
  );
};

export default ReviewTemplates;
